module.exports = "/_next/static/images/Hero-34db3863c843959d82f2be98daa4aa7a.webp";